import { useMemo } from "react";
import {useLocation, useParams} from "react-router-dom";


const useFetchDataFromRoute = () => {
  const {search} = useLocation();
  const dynamicRoutes = useParams();
  return useMemo(() => {
    const queryIterable = new URLSearchParams(search)
    // @ts-ignore
    let query: {[key: string]: string} = Object.fromEntries([...queryIterable]);
    return {...query, ...dynamicRoutes}
  }, [search, dynamicRoutes])
}

export default useFetchDataFromRoute
